import { Search } from '@material-ui/icons'
import {  Popover, TextField, InputAdornment, Divider, } from '@material-ui/core'
import { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './FontAwesomeIconPicker.scss'
import { useFontAwesomeIconPack } from './useFontAwesomeIconPack'



const FontAwesomeIconPicker = ({ value, onChange, id, isEdit= false, delComponent  }) => {
  const [searchText, setSearchText] = useState('')
  const [anchorEl, setAnchorEl] = useState(null)
  const iconPack = useFontAwesomeIconPack()

  // if (!iconPack) {
  //   return <Skeleton variant="rectangular" width={210} height={40} />
  // }

  const iconsFiltered = iconPack?.filter((icon) => {
    return icon.iconName.includes(searchText.toLowerCase())
  })

  return (
    <>
      <div className='font-awesome-selection-container'>
        <div className='font-div'>
          {value && (
            <FontAwesomeIcon icon={['fas', value]} color="#0060f0" size='2x' />
          )}
        </div>
        <button className='common-btn' type="button" onClick={(e) => setAnchorEl(e.currentTarget)}>
          {isEdit ? "Edit Icon" : "Select Icon" }
        </button>
            
        <Popover
        className="iconPicker"
        id={anchorEl ? 'iconPickerPopover' : undefined}
        open={!!anchorEl}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        PaperProps={{
          className: 'iconPicker__paper'
        }}
      >
        <div className="iconPicker__popoverContainer">
          <div className="iconPicker__popoverHeader">
            <TextField
              fullWidth
              placeholder="Search"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search />
                  </InputAdornment>
                )
              }}
              size="small"
              variant="outlined"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
            />
          </div>
          <Divider />
          <div className="iconPicker__iconsContainer">
            {iconsFiltered?.map((icon) => (
              <div className="iconPicker__iconWrapper" key={icon.iconName}>
                <button
                  className={`iconPicker__iconItem ${icon.iconName === value ? 'selected' : ''}`}
                  title={icon.iconName}
                  onClick={() => onChange?.(id, "icon",icon.iconName)}
                >
                  <FontAwesomeIcon icon={icon} />
                </button>
              </div>
            ))}
          </div>
        </div>
      </Popover>
      </div>

    </>
  )
}
export default FontAwesomeIconPicker
